<template>
  <split-panel-page :scroll="false" :showRight="showHelp">
    <content-nav-bar class="content-nav-bar">
      <h5 class="is-size-4 has-text-centered level-item">Create Analytic Admin</h5>
      <a v-on:click="submit()" class="add button level-item">
        <i class="far fa-save"></i>
        Save
      </a>
      <p v-if="validMessage" class="message level-item">{{ validMessage }}</p>
      <loader class="level-item" :showLoader="showLoader">Saving Analytic</loader>
      <template slot="right">
        <a @click="showHelp = !showHelp" class="help-toggle">
          {{ helpMessage }} <i class="far fa-life-ring"></i>
        </a>
      </template>
    </content-nav-bar>
    <div class="full-height-scroll">
      <analytic-form
        :analytic.sync="internalAnalytic"
        v-on:update:analyticEventDef="eventDef = $event">
        <div class="form-section">
          <fieldset class="fieldset">
            <legend>Analytic Status</legend>
            <b-switch v-model="released">
              Released
            </b-switch>
          </fieldset>
        </div>
      </analytic-form>
    </div>
    <template slot="right">
      <content-nav-bar>
        <h5 class="is-size-4 has-text-centered level-item">Analytic Documentation</h5>
      </content-nav-bar>
      <analytic-help-panel
        v-if="eventDef"
        :def="eventDef"
        v-bind:class="{ 'hide-help': !showHelp }"
        class="help-section full-height-scroll">
      </analytic-help-panel>
    </template>
  </split-panel-page>
</template>

<script>
import AnalyticForm from '@/components/analytics/forms/AnalyticForm.vue';
import AnalyticHelpPanel from '@/components/analytics/AnalyticHelpPanel.vue';
import SplitPanelPage from '@/components/SplitPanelPage.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'AnalyticCreateAdmin',
  components: {
    AnalyticForm,
    AnalyticHelpPanel,
    SplitPanelPage,
    ContentNavBar,
    Loader,
  },
  methods: {
    async submit() {
      this.showLoader = true;
      const analytic = await this.$store.dispatch('admin/createAnalytic', this.internalAnalytic);
      this.showLoader = false;
      if (analytic) {
        this.$router.push({ name: 'admin.analytics.index.detail', params: { id: analytic.uuid } });
      }
    },
  },
  data() {
    return {
      released: false,
      eventDef: null,
      showHelp: true,
      validMessage: null,
      internalAnalytic: this.$typeDefs.configs.analytic,
      showLoader: false,
    };
  },
  computed: {
    helpMessage() {
      if (this.showHelp) {
        return 'Hide Help';
      }
      return 'Show Help';
    },
  },
};
</script>

<style lang="scss" scoped>
.full-height-scroll {
  flex-grow: 1;
  height: 100%;
  padding-bottom: 2rem;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
